import Lenis from "lenis";

const reduced = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function initUi() {
  const header = document.querySelector(".site-header");
  const callBar = document.getElementById("call-bar");
  const mnav = document.querySelector(".mnav");
  const year = document.getElementById("year");
  if (year) year.textContent = String(new Date().getFullYear());

  let lenis = null;
  if (!reduced()) {
    lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    const raf = (t) => {
      lenis.raf(t);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }

  const onScroll = () => {
    const y = window.scrollY;
    header?.classList.toggle("is-scrolled", y > 8);
    callBar?.classList.toggle("is-visible", y > 640);
  };
  if (lenis) lenis.on("scroll", onScroll);
  else window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  document.addEventListener("click", (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute("href");
    const target = id === "#top" ? document.body : document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    if (mnav) mnav.open = false;
    const offset = -(header?.offsetHeight || 76) - 12;
    if (lenis) lenis.scrollTo(id === "#top" ? 0 : target, { offset, duration: 1.4 });
    else window.scrollTo({ top: id === "#top" ? 0 : target.getBoundingClientRect().top + window.scrollY + offset });
    history.replaceState(null, "", id);
  });

  document.addEventListener("click", (e) => {
    if (mnav?.open && !mnav.contains(e.target)) mnav.open = false;
  });

  const tocLinks = [...document.querySelectorAll(".tech-nav a")];
  if (tocLinks.length && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          tocLinks.forEach((l) => l.classList.toggle("is-active", l.getAttribute("href") === `#${en.target.id}`));
          const act = tocLinks.find((l) => l.classList.contains("is-active"));
          const nav = act?.parentElement;
          if (act && nav) nav.scrollTo({ left: act.offsetLeft - 8, behavior: "smooth" });
        });
      },
      { rootMargin: "-35% 0px -55% 0px" }
    );
    tocLinks.forEach((l) => {
      const t = document.querySelector(l.getAttribute("href"));
      if (t) io.observe(t);
    });
  }
  return lenis;
}
